
import { useEffect } from "react";
import { initNative } from "@/lib/native/bootstrap";

/**
 * Fire-and-forget native bootstrap. Mounted once in the root layout.
 * On web this is a cheap no-op (only hydrateStorage runs, and on web it's instant).
 */
export function NativeBoot() {
  useEffect(() => {
    initNative().catch((err) => console.error("[native boot]", err));
  }, []);
  return null;
}
